import { take } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { OverlayService } from 'src/app/shared/modules/overlay/services/overlay.service';
import { FinancialTransactionItemComponent } from '../../organisms/financial-transaction-item/financial-transaction-item.component';
import { FinancialTransactionActions } from '../../../state/financial-transactions.action-types';
import { savingSuccessStateById } from '../../../state/financial-transactions.selectors';
import { WindowScrollService } from 'src/app/shared/services/window-scroll.service';
import { AppState } from 'src/app/app.states';
import { Store } from '@ngrx/store';
import { UsersSelectors } from 'src/app/features/users/state/users.selector-types';
import { UserStatus } from 'src/app/shared/enums/UserStatus.enum';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { InvestorCapabilitiesService } from 'src/app/shared/services/investor-capabilities.service';

@Component({
  selector: 'app-create-financial-transaction-withdraw',
  templateUrl: './create-financial-transaction-withdraw.component.html',
  styleUrls: ['./create-financial-transaction-withdraw.component.scss'],
})
export class CreateFinancialTransactionWithdrawComponent implements OnInit {
  selectedUserId;
  profile;

  constructor(
    private overlayService: OverlayService,
    private windowScrollService: WindowScrollService,
    private store: Store<AppState>,
    private featureFlagService: FeatureFlagService,
    private investorCapabilities: InvestorCapabilitiesService
  ) {}

  ngOnInit() {
    this.setLocalStorage();

    this.store
      .select(UsersSelectors.profile())
      .pipe(take(1))
      .subscribe((profile) => {
        this.profile = profile;
      });
  }

  /**
   * FIN-1709 · this screen asked for `status === 'approved'` directly, which is a fourth
   * copy of the rule the route guard, the side menu and the *Añadir fondos* button all
   * ask a different way. The route opens for a pre-approved inversionista, who then
   * landed on the "tu cuenta está en proceso de validación" notice instead of the form.
   *
   * FIN-1711 · it opened for a disapproved inversionista holding money too (FIN-1714);
   * that standing is gone, so this is the pre-approved window only.
   *
   * Flag off it is the original condition, character for character.
   */
  canWithdraw(): boolean {
    if (!this.featureFlagService.isEarlyDepositEnabled()) {
      return this.profile?.status === UserStatus.Approved;
    }

    return this.investorCapabilities.capabilitiesFor(this.profile).withdraw;
  }

  selectedUserChanged(userId) {
    if (userId) {
      this.selectedUserId = userId;
    }
  }

  openIntercom() {
    (<any>window).Intercom('show');
  }

  submitHandler(formValue) {
    this.sendEventPageView(2);
    this.overlayService.startConfirmation(
      formValue,
      FinancialTransactionItemComponent,
      'details',
      'create',
      'Dependiendo del banco, el retiro se podría hacer efectivo en tu cuenta en un promedio de 48 horas, aunque puede ser más rápido.\n\n\nRecuerda que cualquier costo o comisión por la transferencia será asumido por el inversionista.',
      FinancialTransactionActions.Saving,
      '/financial-transactions',
      savingSuccessStateById,
      {
        onSuccess: {
          showIcon: true,
          showCheck: false,
          iconName: 'withdraw',
          title: 'Retiro en proceso',
          messsage:
            '<span class="bold">Te llegará un correo confirmando la aprobación de tu retiro.</span> Recuerda que el retiro se podría hacer efectivo en tu cuenta en un promedio de 48 horas.',
        },
      },
      this.sendEventPage.bind(this)
    );
  }

  sendEventPage() {
    this.sendEventPageView(3);
  }

  setLocalStorage() {
    localStorage.setItem('tab_transactions', '1');
  }

  sendEventPageView(title) {
    this.windowScrollService.sendNewEvent(
      'Financial Transactions',
      `Withdraw Step ${title}`
    );
  }
}
